var _path, _path2, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgViewIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.7684 8.80954C12.7442 9.78537 12.7442 11.3695 11.7684 12.347C10.7926 13.3229 9.2084 13.3229 8.2309 12.347C7.25507 11.3712 7.25507 9.78704 8.2309 8.80954C9.2084 7.83204 10.7917 7.83204 11.7684 8.80954",
    stroke: "url(#paint0_linear_1306_29000)",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.5 10.5763C2.5 10.0271 2.62667 9.48375 2.87167 8.98292V8.98292C4.13417 6.40209 6.92417 4.74292 10 4.74292C13.0758 4.74292 15.8658 6.40209 17.1283 8.98292V8.98292C17.3733 9.48375 17.5 10.0271 17.5 10.5763C17.5 11.1254 17.3733 11.6688 17.1283 12.1696V12.1696C15.8658 14.7504 13.0758 16.4096 10 16.4096C6.92417 16.4096 4.13417 14.7504 2.87167 12.1696V12.1696C2.62667 11.6688 2.5 11.1254 2.5 10.5763Z",
    stroke: "url(#paint1_linear_1306_29000)",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1306_29000",
    x1: 8.06096,
    y1: 8.07641,
    x2: 12.2185,
    y2: 8.40029,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF7999"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFBA52"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1306_29000",
    x1: 4.18539,
    y1: 4.74292,
    x2: 16.6059,
    y2: 5.98723,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF7999"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFBA52"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgViewIcon);
export default __webpack_public_path__ + "static/media/view-icon.dc67006e4b927576f6e4e1d1d8ff6d14.svg";
export { ForwardRef as ReactComponent };